import { render, staticRenderFns } from "./OfertaCreate.vue?vue&type=template&id=2754b35a&scoped=true&"
import script from "./OfertaCreate.vue?vue&type=script&lang=js&"
export * from "./OfertaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2754b35a",
  null
  
)

export default component.exports